import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const NameTypography = styled(Typography)({
  textTransform: 'uppercase',
});

const NameDisplay = styled('span')({
  textTransform: 'uppercase',
});

export { NameTypography };
export default NameDisplay;
